export default __webpack_public_path__ + "static/media/inspirasi-terkini2.d3d8ea92.png";